import { Box, Stack, Typography, Grid } from "@mui/material";
import { colors, shadows } from "../source/source.styles";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import GroupIcon from "@mui/icons-material/Group";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PercentIcon from "@mui/icons-material/Percent";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

const KPICard = ({ icon, iconBg, title, value, secondaryValue, trend, trendType }) => {
  const TrendIcon = trendType === "up" ? TrendingUpIcon : TrendingDownIcon;
  const trendColor = trendType === "up" ? colors.success : colors.success;

  return (
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        borderRadius: 3,
        p: 3,
        border: `1px solid ${colors.borderLight}`,
        boxShadow: shadows.card,
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: shadows.cardHover,
          transform: "translateY(-2px)",
        },
      }}
    >
      {/* Row 1: Title + Icon */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.5,
            color: colors.textMuted,
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 2,
            bgcolor: iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
      </Stack>

      {/* Row 2: Value(s) */}
      <Stack direction="row" alignItems="baseline" spacing={1.5} mb={1}>
        <Typography
          sx={{
            fontSize: secondaryValue ? 32 : 28,
            fontWeight: 700,
            color: colors.textPrimary,
            lineHeight: 1.2,
          }}
        >
          {secondaryValue || value}
        </Typography>
        {secondaryValue && (
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              color: colors.textPrimary,
              opacity: 0.7,
            }}
          >
            {value}
          </Typography>
        )}
      </Stack>

      {/* Row 3: Trend */}
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <TrendIcon sx={{ fontSize: 14, color: trendColor }} />
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            color: trendColor,
          }}
        >
          {trend}
        </Typography>
      </Stack>
    </Box>
  );
};

const DSPKPICards = ({ data }) => {
  const cards = [
    {
      icon: <GroupIcon sx={{ fontSize: 18, color: colors.chartBlue }} />,
      iconBg: "#EFF6FF",
      title: "TOTAL LEADS",
      value: data.totalLeads.value,
      trend: data.totalLeads.trend,
      trendType: data.totalLeads.trendType,
    },
    {
      icon: <CurrencyRupeeIcon sx={{ fontSize: 18, color: colors.chartOrange }} />,
      iconBg: "#FFFBEB",
      title: "AVG REVENUE PER LEAD",
      value: `₹${data.avgRevenuePerLead.value.toLocaleString()}`,
      trend: data.avgRevenuePerLead.trend,
      trendType: data.avgRevenuePerLead.trendType,
    },
    {
      icon: <PercentIcon sx={{ fontSize: 18, color: colors.success }} />,
      iconBg: "#ECFDF5",
      title: "LEAD CONVERSION",
      value: `${data.conversion.value}%`,
      secondaryValue: data.conversion.count,
      trend: data.conversion.trend,
      trendType: data.conversion.trendType,
    },
    {
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 18, color: colors.chartPurple }} />,
      iconBg: "#F5F3FF",
      title: "TOTAL REVENUE",
      value: `₹${data.revenue.value.toLocaleString()}`,
      trend: data.revenue.trend,
      trendType: data.revenue.trendType,
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
          <KPICard {...card} />
        </Grid>
      ))}
    </Grid>
  );
};

export default DSPKPICards;
